module.exports = __webpack_public_path__ + "img/mooma-logo.0e558731.svg";